// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import { formatDateTime } from "@transformers/date";
import { View, Text, SwitchButton } from "@components";
import type { UserAccount } from "@modules/employee/reducer/user-account-details/types";

type Props = {
  ...PropsFromLocalize,
  userAccount: UserAccount,
  blockAccount: () => void,
  unblockAccount: () => void,
  onToggleSetEmailModal: () => void,
  unlockTempBlockedAccount: () => void,
};

const AccountDetails = ({
  userAccount,
  blockAccount,
  unblockAccount,
  onToggleSetEmailModal,
  unlockTempBlockedAccount,
  t,
}: Props) => {
  const handleUserAccountStatus = () => {
    if (!userAccount?.email) {
      onToggleSetEmailModal();
      return;
    }

    if (userAccount?.isAccountEnabled) {
      blockAccount();
    } else {
      unblockAccount();
    }
  };

  return (
    <View flex={1} gap={3} padding="1rem 0 0 0">
      <View direction="row" alignItems="center" justifyContent="space-between">
        <Text color="charcoal">{t("STATUS")}</Text>
        <SwitchButton
          active={userAccount?.isAccountEnabled}
          onChange={handleUserAccountStatus}
          activeLabel={t("ENABLED")}
          inactiveLabel={t("DISABLED")}
          className="w-112-px"
          disabledStyles="bg-negative borders-color-negative"
        />
      </View>
      <View direction="row" alignItems="center" justifyContent="space-between">
        <Text color="charcoal">{t("BLOCKED_TEMPORARY")}</Text>
        <SwitchButton
          active={userAccount?.isAccountTemporaryLocked}
          disabled={!userAccount?.isAccountTemporaryLocked}
          onChange={unlockTempBlockedAccount}
          activeLabel={t("LOCKED")}
          inactiveLabel={t("UNLOCKED")}
          className="w-112-px"
          enabledStyles="bg-negative borders-color-negative"
        />
      </View>
      <View direction="row" alignItems="center" justifyContent="space-between">
        <Text color="charcoal">{t("DATE_REGISTERED")}</Text>
        <Text>
          {userAccount && userAccount.registeredAt
            ? formatDateTime(userAccount.registeredAt)
            : t("N/A")}
        </Text>
      </View>
    </View>
  );
};

export default compose(localize())(AccountDetails);
